import { Storage } from 'types/common';

export const CATEGORY = {
  SLD: 'SLD',
  CEC: 'CEC',
  CSA_Z462: 'CSA_Z462',
  CSA_Z463: 'CSA_Z463',
  GEOLOCATIONS: 'Geolocations',
  IEEE: 'IEEE',
  BUILDING_CODE: 'Building_Code',
  FIRE_CODE: 'Fire_Code',
  ASSETS: 'Assets',
  MODELS: 'Models'
} as const;

/** Library folder row from GET /documentation-categories */
export type DocumentationCategoryRow = {
  id: string;
  slug: string;
  sortOrder: number;
  createdAt?: string;
  updatedAt?: string;
};
export type Documentation = {
  id: number;
  name: string;
  storageId: number;
  category: TypeCategory;
  storage: Storage;
  url: string;
};
export type TypeCategory = (typeof CATEGORY)[keyof typeof CATEGORY];
export type ParamGetDocument = Partial<{
  category: string;
  clientId: string;
  roomId: number;
  page: number;
  size: number;
  keyword: string;
}>;
export type FormAddDocument = {
  name: string;
  clientIds?: string[];
  category?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  file: any;
};
